<template>
  <div class="wild-search">
    <div class="header mr-0.5" ref="header">
      <el-form size="mini" class="flex items-center gap-0.5">
        <el-popover placement="bottom" class="-mt-0.5" trigger="click">
          <ContainerFilter :filter="filter" @search="loadOrders" />
          <el-button slot="reference" icon="el-icon-search" size="mini">
            Filters
          </el-button>
        </el-popover>
        <el-button-group v-if="isAdmin">
          <el-button size="mini" @click="exportCsv" title="Max 1000 Records">
            Export to CSV
          </el-button>
        </el-button-group>
      </el-form>
    </div>
    <div
      v-for="name in ['confirmedImports', 'confirmedExports']"
      :key="name"
      :name="name"
      class="box"
    >
      <div class="box-title show-hide">
        <div class="count">{{ data[name].pagination.total }}</div>
        <div>{{ data[name].title }}</div>
      </div>
      <div class="box-content">
        <ContainerOrderStackTable
          v-if="!isEmptyData(data[name].items)"
          :items="data[name].items"
          :selector="false"
          :financials="financials"
          :auto-height="true"
        />
        <el-pagination
          v-if="!isEmptyData(data[name].items)"
          background
          layout="prev, pager, next"
          :page-size="data[name].pagination.pageSize"
          :current-page="data[name].pagination.currentPage"
          :total="data[name].pagination.total"
          @current-change="pageChange($event, name)"
        >
        </el-pagination>
      </div>
    </div>
    <div
      v-for="name in ['unconfirmedImports', 'unconfirmedExports']"
      :key="name"
      :name="name"
      class="box"
    >
      <div class="box-title show-hide">
        <div class="count">{{ data[name].pagination.total }}</div>
        <div>{{ data[name].title }}</div>
      </div>
      <div class="box-content">
        <slot v-if="isAdmin">
          <ContainerPreAlertTable
            v-if="!isEmptyData(data[name].items)"
            :type="data[name].type"
            :items="data[name].items"
            :selector="false"
            :auto-height="true"
          />
        </slot>
        <slot v-else>
          <ContainerBrief
            v-if="!isEmptyData(data[name].items)"
            type="Import"
            :items="data[name].items"
          />
        </slot>
        <el-pagination
          v-if="!isEmptyData(data[name].items)"
          background
          layout="prev, pager, next"
          :page-size="data[name].pagination.pageSize"
          :current-page="data[name].pagination.currentPage"
          :total="data[name].pagination.total"
          @current-change="pageChange($event, name)"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/default/utils/api";
import ContainerFilter from "@/default/pages/containers/filter.vue";
import ContainerOrderStackTable from "@/default/pages/containers/order_stack/table.vue";
import ContainerPreAlertTable from "@/default/pages/containers/pre_alert/table.vue";
import ContainerBrief from "@/default/pages/containers/brief.vue";

export default {
  name: "ContainerWildSearch",
  mixins: [api],
  components: {
    ContainerFilter,
    ContainerOrderStackTable,
    ContainerPreAlertTable,
    ContainerBrief,
  },
  props: {
    id: {
      type: String,
      required: false,
      default: "",
    },
    keyword: {
      type: String,
      required: false,
      default: "",
    },
    financials: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      envs: {},
      filter: {
        keyword: this.keyword,
        id_eq: this.id,
        locked_eq: null,
        confirmed_eq: null,
        dispatched: null,
        page_size: 50,
      },
      data: {
        confirmedImports: {
          title: "Confirmed Imports",
          items: [],
          type: "import",
          status: "confirmed",
          mode: "order-stack",
          pagination: {
            total: 0,
            pageSize: 10,
            currentPage: 1,
          },
        },
        confirmedExports: {
          title: "Confirmed Exports",
          items: [],
          type: "export",
          status: "confirmed",
          mode: "order-stack",
          pagination: {
            total: 0,
            pageSize: 10,
            currentPage: 1,
          },
        },
        unconfirmedImports: {
          title: "Unconfirmed Imports",
          items: [],
          type: "import",
          status: "unconfirmed",
          mode: "pre-alert",
          pagination: {
            total: 0,
            pageSize: 10,
            currentPage: 1,
          },
        },
        unconfirmedExports: {
          title: "Unconfirmed Exports",
          items: [],
          type: "export",
          status: "unconfirmed",
          mode: "pre-alert",
          pagination: {
            total: 0,
            pageSize: 10,
            currentPage: 1,
          },
        },
      },
    };
  },
  mounted() {
    this.moveHeader();
    window.addEventListener("ReloadOrder", this.reloadOrder);
  },
  created() {
    this.loadOrders();
  },
  methods: {
    moveHeader() {
      const btns = document.querySelector(".title-bar .buttons");
      if (btns) btns.appendChild(this.$refs.header);
    },
    exportCsv() {
      const q = { ...this.filter };
      delete q.page_size;
      this.getDownload("/api/v1/containers/wild.csv", { q });
    },
    reloadOrder(event) {
      const id = parseInt(event.detail);
      for (const key in this.data) {
        const group = this.data[key];
        let index = group.items.findIndex((o) => o.id == id);
        if (index >= 0) {
          this.$http
            .get(`/api/v1/containers/${id}`, { params: { mode: group.mode } })
            .then((response) => {
              const item = this.processItems([response.data])[0];
              group.items.splice(index, 1, item);
            })
            .catch((err) => {});
        }
      }
    },
    searchFilter() {
      const q = { ...this.filter };
      delete q.page_size;
      return q;
    },
    loadOrders() {
      for (const key in this.data) {
        const group = this.data[key];
        this.loadGroupedOrders(group);
      }
    },
    loadGroupedOrders(group) {
      this.$http
        .get("/api/v1/containers/wild", {
          params: {
            q: this.searchFilter(),
            status: group.status,
            type: group.type,
            page: group.pagination.currentPage,
            page_size: this.filter.page_size,
          },
        })
        .then((response) => {
          const data = response.data;
          group.pagination.pageSize = parseInt(data.page_size);
          group.pagination.total = parseInt(data.total);
          group.items = this.processItems(data.containers, group.status);
        })
        .catch((err) => {});
    },
    pageChange(val, key) {
      const group = this.data[key];
      group.pagination.currentPage = val;
      this.loadGroupedOrders(group);
    },
    processItems(items, status) {
      return items.map((item) => this.processItem(item, status));
    },
    processItem(item, status) {
      try {
        if (status == "confirmed") {
          const cs = this._.uniqBy(
            this._.flatten(
              item.transports.map((o) => o.operations.map((o) => o.company)),
            ),
            "id",
          );
          item.terminals = cs.filter((o) => ["Terminal"].includes(o.type));
          item.depots = cs.filter((o) => ["Depot"].includes(o.type));
          item.warehouses = cs.filter((o) => ["Warehouse"].includes(o.type));
          item.truckers = item.transports.map((o) => [o.trucker, o.carrier]);
          item.truckers = item.truckers.flat().filter((o) => o.id);
          if (this.isAdmin || this.isCustomer) {
            item.receivable_invoice_numbers = item.receivable.invoices
              .map((o) => o.number)
              .join(";");
            item.receivable_payment_numbers = item.receivable.payments
              .map((o) => o.number)
              .join(";");
            item.receivable_amount = parseFloat(item.receivable.charges.amount);
          }
          if (this.isAdmin || this.isTrucker) {
            item.payable_invoice_numbers = item.payable.invoices
              .map((o) => o.number)
              .join(";");
            item.payable_payment_numbers = item.payable.payments
              .map((o) => o.number)
              .join(";");
            item.payable_amount = parseFloat(item.payable.charges.amount);
          }
        }
        return item;
      } catch (ex) {
        console.log(ex);
      }
    },
  },
};
</script>
<style lang="scss">
.wild-search {
  .box-title {
    @apply flex items-center gap-1;
    .count {
      @apply size-5 rounded-full bg-blue-500 text-white text-2xs font-bold flex items-center justify-center;
    }
  }
  .box-content {
    @apply empty:hidden;
  }
}
</style>
